import TablePeriod from "./table-period";
import TableRowPeriodTime from "./table-period-time";
import TableResource from "./table-resource";
import PeriodStatusType from "./period-status-type";

import TableFixedPeriods from "./directive";

const modul = angular
    .module("searchPeriodsFixedTableComponents", [])

    .directive("tableFixedPeriods", TableFixedPeriods)

    .directive("tablePeriod", TablePeriod)
    .directive("tableRowPeriodTime", TableRowPeriodTime)
    .directive("periodStatusType", PeriodStatusType)
    .directive("tableResource", TableResource);

export default modul.name;
